import { render } from "./PendingAccounts.vue?vue&type=template&id=69215c28&scoped=true&ts=true"
import script from "./PendingAccounts.vue?vue&type=script&lang=ts"
export * from "./PendingAccounts.vue?vue&type=script&lang=ts"

import "./PendingAccounts.vue?vue&type=style&index=0&id=69215c28&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69215c28"]])

export default __exports__